import { useRecoilValue } from 'recoil'

import { $tenantConfiguration } from './selectors'

export function useTenantConfiguration() {
  const tenantConfig = useRecoilValue($tenantConfiguration)
  return tenantConfig
}

export function useEntityLoggingEnabled(entityName: string) {
  const tenantConfig = useTenantConfiguration()
  const entityEnabled = tenantConfig?.logging.enabledLoggingEntities.find((e) => e === entityName)
  return tenantConfig?.logging.loggingDataEnabled && entityEnabled
}

export function useEntityJournalingEnabled(entityName: string) {
  const tenantConfig = useTenantConfiguration()
  const entityEnabled = tenantConfig?.logging.enabledJournalingEntities.find((e) => e === entityName)
  return tenantConfig?.logging.journalingDataEnabled && entityEnabled
}
